import { toggle } from "../../../store/reducers/mobileMenuSlice";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import Link from "../../styled/link";
import { MenuItem } from "./common";

const MenuWrapper = styled.div`
  min-width: 160px;
  background: ${(p) => p.theme.fillPanel};
  @media screen and (max-width: 900px) {
    position: static;
    box-shadow: none;
    transform: none;
    padding: 0;
    border: none;
  }
`;

export default function Navi() {
  const dispatch = useDispatch();
  const closeMobileMenu = () => {
    dispatch(toggle());
  };

  return (
    <MenuWrapper>
      <Link to={"/blocks"} onClick={closeMobileMenu}>
        <MenuItem>Blocks</MenuItem>
      </Link>
      <Link to={"/contracts"} onClick={closeMobileMenu}>
        <MenuItem>Contracts</MenuItem>
      </Link>
      <Link to={"/did"} onClick={closeMobileMenu}>
        <MenuItem>DID</MenuItem>
      </Link>
    </MenuWrapper>
  );
}
